export function shouldAutowireForms(settings) {
   return settings?.autowireForms !== false;
}
